export const getBounding = (element) => {
    if (!element) {
        return;
    };

    const rect = element?.getBoundingClientRect();
    
    if (getComputedStyle(element).direction === "rtl") {
        rect.x = window.innerWidth - rect.x - rect.width;
    };

    return rect;
}